jQuery(document).ready(function($) {





  
   

// Handle size selection
   $(document).on("click", ".two .size-list li, .two .size-list li label", function() {
    // Remove the "checked" class from all size list items
    $(".card-wrapper .two .size-list li").removeClass("checked");

    // Determine the target (either the clicked label or the list item)
    let target = $(this).is("label") ? $(this).closest("li") : $(this);
    target.addClass("checked");

    // Get the product ID from the selected size variant
    let productId = target.find("input[type='radio']").attr("name").replace("size-", "");
    
    // Update the "data-product-id" attribute of the "ADD TO CART" button
    $(".add-to-cart-btn").attr("data-product-id", productId);
});




// Handle "ADD TO CART" button click
  
$(document).ready(function() {
    $(document).on("click", ".add-to-cart-btn", function() {
        let productId = $(this).data("product-id");
        let sizeOptions = $(`input[name="size-${productId}"]`);
        let selectedVariant = $(`input[name="size-${productId}"]:checked`);

        if (sizeOptions.length > 0) {
            if (!selectedVariant.length) {
                alert("Please select a size before adding to cart.");
                return;
            }
        }

        let variantId = selectedVariant.length ? selectedVariant.val() : productId;

        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ id: variantId, quantity: 1 }),
            success: function() {
              // const url = new URL(window.location.href);
              // url.searchParams.set('cart_open', 'true');
              // window.location.href = url.toString();
            },
            error: function(error) {
                console.error("Error adding to cart:", error);
            }
        });
    });
});  

//   $(document).ready(function() {
//     // Check if the URL contains the 'cart_open' parameter
//     const urlParams = new URLSearchParams(window.location.search);
//     if (urlParams.has('cart_open')) {
//         // Open the cart drawer
//         const cartDrawer = document.querySelector('cart-drawer');
//         if (cartDrawer) {
//             $('.cart-trigger').click();
//         }

//         // Remove the 'cart_open' parameter from the URL
//         urlParams.delete('cart_open');
//         const newUrl = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '');
//         window.history.replaceState({}, '', newUrl); // Update the URL without reloading the page
//     }
// });
  
	var owl = $(".banner .owl-carousel");
	  owl.owlCarousel({
		items: 1,
        lazyLoad:true,
		margin: 0,
		loop: true,
		nav: false,
		dots: true,
		autoplay: false,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut'
	  });

  var owl3 = $(".sticky .owl-carousel");
	  owl3.owlCarousel({
		items: 1,
		margin: 0,
        lazyLoad:true,
		loop: false,
		nav: false,
		dots: true,
		autoplay: false,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut'
	  });

    var owl2 = $(".best-sellers .owl-carousel");
	  owl2.owlCarousel({
		items: 1,
		margin: 20,
        lazyLoad:true,
		loop: true,
		nav: true,
		dots: false,
		autoplay: false,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        responsive: {
		  0: {
			items: 1
		  },
		  768: {
			items: 2
		  },
		  1037: {
			items: 4
		  },
        navText: ["<i class='bi bi-arrow-left'></i>", "<i class='bi bi-arrow-right'></i>"]
		}
	  });


  $('section.best-sellers .tab-men').click(function() {
      $('section.best-sellers .tab-women').removeClass('active');
      $('section.best-sellers .tab-men').addClass('active');
  });
  $('section.best-sellers .tab-women').click(function() {
      $('section.best-sellers .tab-men').removeClass('active');
      $('section.best-sellers .tab-women').addClass('active');
  });

  $('header .left .mobile-menu-toggle').click(function() {
      $('html').toggleClass('overflow-hidden');
      $('header .mega-menu').removeClass('active');
      $('header .left .menu').toggleClass('active');
      $('header .left .mobile-menu-toggle svg.close').toggleClass('active');
      $('header .left .mobile-menu-toggle svg.open').toggleClass('active');
  });  
	
});

// document.querySelectorAll(".add-to-cart-btn").forEach(button => {
//     button.addEventListener("click", function () {
//         let productId = this.getAttribute("data-product-id");
//         let sizeOptions = document.querySelectorAll(`input[name="size-${productId}"]`);
//         let selectedVariant = document.querySelector(`input[name="size-${productId}"]:checked`);
        
//         // Check if the product has variants (size options)
//         if (sizeOptions.length > 0) {
//             if (!selectedVariant) {
//                 alert("Please select a size before adding to cart.");
//                 return;
//             }
//         }

//         let variantId = selectedVariant ? selectedVariant.value : productId; // Use variant ID if available, else use product ID

//         fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: variantId, quantity: 1 })
//         })
//         .then(response => response.json())
//         .then(() => {
//             window.location.href = "/cart";
//         })
//         .catch(error => {
//             console.error("Error adding to cart:", error);
//         });
//     });
// });


gsap.registerPlugin(ScrollTrigger);


if ($(window).width() > 1036) {

let sections = gsap.utils.toArray(".content");
let images = gsap.utils.toArray(".main img");

// Hide all images initially except the first one
gsap.set(images, { autoAlpha: 0 });
gsap.set(images[0], { autoAlpha: 1 });

gsap.to(sections, {
  yPercent: -100 * (sections.length - 1),
  ease: "none",
  scrollTrigger: {
    trigger: ".sticky",
    start: "top top",
    end: "+=" + (sections.length * window.innerHeight),
    pin: true,
    scrub: 1,
    onUpdate: (self) => {
      let currentIndex = Math.round(self.progress * (sections.length - 1));
      images.forEach((img, index) => {
        gsap.to(img, { autoAlpha: index === currentIndex ? 1 : 0, duration: 0.3 });
      });
    }
  }
});

}

$("section.best-sellers .size-list li, section.best-sellers .size-list li label").click(function () {
    $("section.best-sellers .size-list li").removeClass("checked");

    let target = $(this).is("label") ? $(this).closest("li") : $(this);
    target.addClass("checked");
});

$("section.related-products-custom .size-list li, section.related-products-custom .size-list li label").click(function () {
    $("section.related-products-custom .size-list li").removeClass("checked");

    let target = $(this).is("label") ? $(this).closest("li") : $(this);
    target.addClass("checked");
});






$('.search .search-trigger').click(function() {
  $('.search .search-popup').toggleClass('active');
});

document.querySelectorAll('header .row .menu a').forEach(function(menuItem) {
  menuItem.addEventListener('mouseenter', function() {
    document.querySelectorAll('.mega-menu').forEach(function(megaMenu) {
      megaMenu.classList.remove('active');
    });

    if (menuItem.textContent.toLowerCase().includes('women')) {
      document.querySelector('.mega-menu#women').classList.add('active');
    } else if (menuItem.textContent.toLowerCase().includes('men')) {
      document.querySelector('.mega-menu#men').classList.add('active');
    }
  });
});

document.querySelector('header').addEventListener('mouseleave', function() {
  // Remove 'active' class when mouse leaves the header
  document.querySelectorAll('.mega-menu').forEach(function(megaMenu) {
    megaMenu.classList.remove('active');
  });
});

// gsap.to(".product__info-container", {
//   scrollTrigger: {
//     trigger: ".product__info-wrapper",
//     start: "top top", // Start when the top of .product__info-wrapper reaches the top of the viewport
//     end: "bottom top", // End when the bottom of .product__info-wrapper reaches the top
//     pin: true, // Stick .product-info inside .product__info-wrapper
//     pinSpacing: false, // Optional: Remove extra spacing
//   }
// });

if ($(window).width() > 1036) {
// Make .row-first sticky to top
gsap.to(".row-first", {
  scrollTrigger: {
    trigger: ".collection-prod-box",
    start: "top 87px", // Start pinning when 100px from the top
    end: "bottom top", // Stop pinning when .collection-prod-box scrolls out
    pin: ".row-first", // Pin only the .row-first element
    pinSpacing: false, // Prevents extra spacing issues
  },
});
}
if ($(window).width() < 1037) {
// Make .row-first sticky to top
gsap.to(".row-first", {
  scrollTrigger: {
    trigger: ".collection-prod-box",
    start: "top 68px", // Start pinning when 100px from the top
    end: "bottom top", // Stop pinning when .collection-prod-box scrolls out
    pin: ".row-first", // Pin only the .row-first element
    pinSpacing: false, // Prevents extra spacing issues
  },
});
}

if ($(window).width() > 767) {
gsap.to(".facets-container", {
  scrollTrigger: {
    trigger: ".facets-wrapper",
    start: "top 145px",
    end: "bottom top",
    pin: ".facets-container",
    pinSpacing: false,
  }
});
}

// gsap.to('.both-wrapper', {
//   scrollTrigger: {
//     trigger: '.product__info-wrapper',
//     start: 'top top',
//     end: 'bottom bottom',
//     scrub: true,
//     pin: true,
//   }
// });


// jQuery(document).ready(function ($) {
//   $('.cart-trigger').click(function () {
//     $('#occ3-drawer').toggleClass('occ3-display-block');
//   });
// });